<script lang="ts">
  import { _ } from "svelte-i18n";
  import { colours } from "$lib/data/colours.data";
  import type { colour, colourVariant } from "$lib/data/colours.data";
  import { ColourOptionType } from "$lib/data/colours.data";
  import Typography from "$lib/components/Typography/Typography.svelte";
  import Colour from "../Colour/Colour.svelte";
  import { createEventDispatcher } from "svelte";

  export let colourOptions: colourVariant[] | false = false;
  export let selectedColourOption: colourVariant | false = false;
  export let small = false;
  export let disabled = false;
  export let rounded = true;
  export let swatchType: ColourOptionType = ColourOptionType.SWATCH;

  let selectedColour: colour | false = false;

  if (selectedColourOption) {
    selectedColour = colours[selectedColourOption.selectedSwatch];
  }

  const dispatch = createEventDispatcher<{
    select: colourVariant | false;
  }>();

  const selectColour = (e: CustomEvent) => {
    selectedColourOption = e.detail;
    dispatch("select", selectedColourOption);
  };
</script>

<style lang="scss">
  .colour-wrapper {
    min-height: 26px;

    .wrapper {
      display: flex;
      max-height: max-content;
    }

    &.swatches {
      .wrapper {
        flex-wrap: wrap;
        gap: 8px;
        padding: 1px;
      }
    }

    &.images {
      .wrapper {
        gap: 3px;
        padding: 4px;
        margin: 0 -4px;

        @include breakpoint(md) {
          gap: 8px;
        }
      }
    }
  }
</style>

<div
  class="colour-wrapper"
  class:swatches={swatchType === ColourOptionType.SWATCH}
  class:images={swatchType === ColourOptionType.IMAGE}
>
  {#if colourOptions}
    <div class="wrapper">
      {#each colourOptions as colourOption}
        <Colour
          {colourOption}
          selected={selectedColourOption &&
            selectedColourOption.selectedSwatch === colourOption.identifier}
          on:select={selectColour}
          inStock={colourOption.inStock}
          {small}
          {disabled}
          {rounded}
        />
      {/each}
    </div>

    {#if selectedColour}
      <Typography theme="on-surface-30" component="span" variant="caption1">
        {selectedColour.label}
        {selectedColourOption && selectedColourOption.inStock
          ? ""
          : "(" + $_("Out of stock") + ")"}
      </Typography>
    {/if}
  {/if}
</div>
